// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_AQ3","cls2":"SingularMentionCitationModal-cls2_N_2 SingularMentionCitationModal-cls1_AQ3"};